import ApprovalProvider from 'innovate/components/ApprovalProvider';
import { ReactNode } from 'react';

const withApprovalProvider = (Component: ReactNode) => {
  const WithApprovalProvider = () => <ApprovalProvider>{Component}</ApprovalProvider>;
  return WithApprovalProvider;
};

export default withApprovalProvider;
